import axios from 'axios';
import { StockMovement } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const createApiInstance = () => {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    });
};

export const stockMovementAPI = {
    getMovementsByCompany: async (companyId: string): Promise<StockMovement[]> => {
        const api = createApiInstance();
        const response = await api.get(`/stock-movements/company/${companyId}`);
        return response.data;
    },

    getMovementsByProduct: async (productId: string): Promise<StockMovement[]> => {
        const api = createApiInstance();
        const response = await api.get(`/stock-movements/product/${productId}`);
        return response.data;
    },

    getMovementsByOrder: async (orderId: string): Promise<StockMovement[]> => {
        const api = createApiInstance();
        const response = await api.get(`/stock-movements/order/${orderId}`);
        return response.data;
    },
};
